let blogdata = [
  {
    source: { id: "la-nacion", name: "La Nacion" },
    author: "Jordi Pérez Colomé",
    title:
      "Más allá de Elon Musk: las seis tendencias tecnológicas más importantes del año",
    description:
      "El nuevo dueño de Twitter es sin duda una historia de 2022, pero hay otras con un impacto mayor",
    url: "https://www.lanacion.com.ar/tecnologia/mas-alla-de-elon-musk-las-seis-tendencias-tecnologicas-mas-importantes-del-ano-nid30122022/",
    urlToImage:
      "https://resizer.glanacion.com/resizer/MVOZdZv6TLCg2omcWQTWKBbnfCE=/768x0/filters:format(webp):quality(80)/cloudfront-us-east-1.images.arcpublishing.com/lanacionar/LR3O4MIQ65GXBDTP3YFSNR4Q2Q.JPG",
    publishedAt: "2022-12-30T15:19:26Z",
    content:
      "Este 2022 ha tenido al menos seis historias sustanciales. La compra de Twitter no es la más importante.\r\nEl 16 de septiembre la newsletter de El País jugueteaba con una petición de texto inverosímil … [+9723 chars]",
  },
  {
    source: { id: "handelsblatt", name: "Handelsblatt" },
    author: "Handelsblatt",
    title:
      "Dow Jones, S&P 500, Nasdaq: Wall Street zum Jahresende erneut unter Druck",
    description:
      "Sorgen um eine drohende Rezession nach den großen Zinsschritten der Fed drücken die Stimmung an der Wall Street. Investoren warten auf den Anfang der nächsten Bilanzsaison.",
    url: "https://www.handelsblatt.com/finanzen/maerkte/marktberichte/dow-jones-sundp-500-nasdaq-wall-street-zum-jahresende-erneut-unter-druck/28897824.html",
    urlToImage:
      "https://www.handelsblatt.com/images/wall-street/28864482/3-format2003.jpg",
    publishedAt: "2022-12-30T15:18:12Z",
    content:
      "Wall Street\r\nNew York Die US-Anleger fassen Aktien am letzten Handelstag des Krisenjahres 2022 nur mit spitzen Fingern an. Der Dow-Jones-Index der Standardwerte eröffnete am Freitag 0,3 Prozent tiefe… [+1871 chars]",
  },
  {
    source: { id: null, name: "Mediafax.ro" },
    author: "Andrei Şerbănescu",
    title: "Analiză 2022: bogaţii lumii au sărăcit cu 1,4 trilioane de dolari",
    description:
      "An de coşmar pentru magnaţii lumii: Elon Musk, Mark Zuckerberg şi cei mai bogaţi 500 de miliardari din lume au pierdut 1,4 trilioane de dolari în 2022, potrivit unei analize prezentate de Ziarul Financiar.",
    url: "https://www.mediafax.ro/economic/analiza-2022-bogatii-lumii-au-saracit-cu-1-4-trilioane-de-dolari-21460000",
    urlToImage:
      "https://storage0.dms.mpinteractiv.ro/media/1/1/1686/21460000/1/jeff-bezos.jpg?width=640",
    publishedAt: "2022-12-30T15:16:30Z",
    content:
      "Cei mai bogai 500 de oameni din lume au pierdut în 2022 aproape 1.400 de miliarde de dolari, potrivit Bloomberg. \r\n Combinat cu inflaia generalizat i însprirea agresiv a politicilor bncilor centrale,… [+2423 chars]",
  },
  {
    source: { id: null, name: "Biztoc.com" },
    author: "mazechmedia.com",
    title:
      "Warren Buffett has surpassed Jeff Bezos in wealth — and threatens to oust Bill Gates as the 2nd-richest American after Elon Musk",
    description:
      "Warren Buffett has surpassed Jeff Bezos in wealth and closed in on Bill Gates this year. • Overtaking Gates would make Buffett the second-richest American, after Elon Musk. • Berkshire Hathaway stock has risen this year whereas Microsoft, Amazon and Tesla sha…",
    url: "https://biztoc.com/x/9ded7f3744b0b1ab",
    urlToImage: "https://c.biztoc.com/p/9ded7f3744b0b1ab/og.webp",
    publishedAt: "2022-12-30T15:06:10Z",
    content:
      "Warren Buffett has surpassed Jeff Bezos in wealth and closed in on Bill Gates this year.Overtaking Gates would make Buffett the second-richest American, after Elon Musk.Berkshire Hathaway stock has r… [+459 chars]",
  },
  {
    source: { id: null, name: "Singularity Hub" },
    author: "Edd Gent",
    title: "2022 Was the Year AI Finally Started Living Up to Its Hype",
    description:
      "Ever since deep learning burst into the mainstream in 2012, the hype around AI research has often outpaced its reality. Over the past year though, a series of breakthroughs and major milestones suggest the technology may finally be living up to its promise. D…",
    url: "https://singularityhub.com/2022/12/30/2022-was-the-year-ai-finally-started-living-up-to-its-hype/",
    urlToImage:
      "https://singularityhub.com/wp-content/uploads/2022/12/deepmind-erunoELfh50-unsplash.jpg",
    publishedAt: "2022-12-30T15:00:05Z",
    content:
      "Ever since deep learning burst into the mainstream in 2012, the hype around AI research has often outpaced its reality. Over the past year though, a series of breakthroughs and major milestones sugge… [+6896 chars]",
  },
  {
    source: { id: null, name: "heise online" },
    author: "Matthias Becker",
    title: "Wenn die Liquiditätsflut abebbt",
    description:
      "Was sind die Gründe für die große Entlassungswelle im Silicon Valley? (Teil1).",
    url: "https://www.heise.de/tp/features/Wenn-die-Liquiditaetsflut-abebbt-7444408.html",
    urlToImage:
      "https://heise.cloudimg.io/bound/1200x1200/q85.png-lossy-85.webp-lossy-85.foil1/_www-heise-de_/imgs/18/3/6/7/1/5/7/4/Master_California-991e9bb1885733a2.jpeg",
    publishedAt: "2022-12-30T15:00:00Z",
    content:
      "San Jose, California. Bild: Michael/CC BY 2.0\r\nWas sind die Gründe für die große Entlassungswelle im Silicon Valley? (Teil1).\r\nElon Musk morgens, Elon Musk abends, Elon Musk rund um die Uhr. Seit der… [+5271 chars]",
  },
  {
    source: { id: null, name: "Lifewire.com" },
    author: "https://www.facebook.com/lifewire/",
    title:
      "New EU Charging Standard Shows How Regulation Could Improve ... - Lifewire",
    description:
      "The European Union recently passed regulations that introducing technology charging standards, and illustrates how government involvement in Big Tech could be beneficial to people, and not just the companies.",
    url: "https://www.lifewire.com/new-eu-charging-standard-shows-how-regulation-could-improve-tech-6951042",
    urlToImage:
      "https://www.lifewire.com/thmb/izUlEyZwj6D-Bn58mvYwziSrePs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Screenshot2022-12-21at10.36.53AM-9300de948212481796c326c9da1c49bc.png",
    publishedAt: "2022-12-30T15:00:00Z",
    content:
      "<ul><li>Apple should have switched to USB-C years ago. </li><li>The EU is better suited than the US to reign in big tech</li><li>Every other industry thrives despite regulation.</li></ul>\r\nNative Uni… [+4790 chars]",
  },
  {
    source: { id: null, name: "Biztoc.com" },
    author: "businessinsider.com",
    title:
      "Warren Buffett has surpassed Jeff Bezos in wealth — and threatens to oust Bill Gates as the 2nd-richest American after Elon Musk",
    description:
      "Warren Buffett. Kevin Lamarque/Reuters Warren Buffett has surpassed Jeff Bezos in wealth and closed in on Bill Gates this year. Overtaking Gates would make Buffett the second-richest American, after Elon Musk. Berkshire Hathaway stock has risen this year whil…",
    url: "https://biztoc.com/x/8fdb237cd2d32bf9",
    urlToImage: "https://c.biztoc.com/p/8fdb237cd2d32bf9/og.webp",
    publishedAt: "2022-12-30T14:50:05Z",
    content:
      "Warren Buffett.Kevin Lamarque/ReutersWarren Buffett has surpassed Jeff Bezos in wealth and closed in on Bill Gates this year.Overtaking Gates would make Buffett the second-richest American, after Elo… [+469 chars]",
  },
  {
    source: { id: "business-insider", name: "Business Insider" },
    author: "bevans@insider.com (Brian Evans)",
    title:
      "Tesla stock to close out worst year ever with a 65% loss in 2022, wiping out more than $700 billion in market cap",
    description:
      "The Tesla stock sell-off has far outpaced the losses of major indices including the S&P 500 and the tech-heavy Nasdaq.",
    url: "https://markets.businessinsider.com/news/stocks/tesla-stock-worst-year-ever-700-billion-market-cap-loss-2022-12",
    urlToImage:
      "https://i.insider.com/63652893ff27460018ed9e58?width=1200&format=jpeg",
    publishedAt: "2022-12-30T14:49:03Z",
    content:
      "Tesla stock ticked up Friday, the last trading day of 2022, but is on track to close out its worst year in the company's history. \r\nShares have lost about 65% from the start of the year, amounting to… [+1241 chars]",
  },
  {
    source: { id: null, name: "BBC News" },
    author: "http://www.facebook.com/bbcnews",
    title:
      "Чому відсторонили мера Чернігова і що він каже про конфлікт з офісом Зеленського",
    description:
      '"Ось з того боку від нас - Білорусь", - показує напрямок нового можливого наступу на Україну з позиції свого кабінету в Чернігові Владислав Атрошенко. Формально суд відсторонив його від виконання обов\'язків міського голови через адмінправопорушення, а саме - …',
    url: "https://www.bbc.com/ukrainian/features-64127142",
    urlToImage:
      "https://ichef.bbci.co.uk/news/1024/branded_ukrainian/310B/production/_128155521_321899552_880877169926930_897833374532945688_n.jpg",
    publishedAt: "2022-12-30T14:46:03Z",
    content:
      '" - ", - . \' , - . , .\r\n , . - , , , - .\r\n .\r\n , \' , . , . , .\r\n News , : , . .\r\n \' , . News .\r\n7 \' , . .\r\n , , , Tesla Model X . . .\r\n " ". " \' , - . ", - \' .\r\n , . " , 2020 " ".\r\n 77,5% . . " " 26 … [+711 chars]',
  },
  {
    source: { id: null, name: "MarketWatch" },
    author: "Philip van Doorn",
    title: "Deep Dive: These 20 stocks were the biggest losers of 2022",
    description:
      "Valuations for the most expensive Big Tech stocks finally fell to more reasonable levels in 2022, as a very big name suffered the biggest decline in market capitalization",
    url: "https://www.marketwatch.com/story/these-20-stocks-were-the-biggest-losers-of-2022-11672360725",
    urlToImage: "https://images.mktw.net/im-694330/social",
    publishedAt: "2022-12-30T14:45:00Z",
    content:
      "This has been the year of reckoning for Big Tech stocks even those of companies that have continued to grow sales by double digits.Below is a list of the 20 stocks in the S&amp;P 500 \r\n SPX,\r\n -0.90%… [+8358 chars]",
  },
  {
    source: { id: null, name: "StockNews.com" },
    author: "RashmiKumari",
    title: "3 Retail Stocks You’ll Be Glad You Bought Before 2023",
    description:
      "The retail industry is expected to remain buoyed as consumers show resilience in the face of mounting recession concerns. Therefore, we think fundamentally sound retail stocks Kroger (KR), Casey’s General...",
    url: "https://stocknews.com/news/kr-casy-bke-3-retail-stocks-youll-be-glad-you-bought-before-2023/",
    urlToImage:
      "https://assets.entrepreneur.com/providers/stocknews/hero-image-stocknews-442048.jpeg",
    publishedAt: "2022-12-30T14:43:53Z",
    content:
      "The retail industry is expected to remain buoyed as consumers show resilience in the face of mounting recession concerns. Therefore, we think fundamentally sound retail stocks Kroger (KR), Caseys Gen… [+6648 chars]",
  },
  {
    source: { id: null, name: "Marketscreener.com" },
    author: "MarketScreener",
    title: "In 2022, the dance floor is empty",
    description:
      "(marketscreener.com) There's been plenty of scandals, tech giants tumbled and Covid stocks got a hungover: we've seen better than 2022. Christine Lagarde and Jerome Powell have been pushing up rates, Putin is bogged down in Ukraine and Elon Musk is messing wi…",
    url: "https://www.marketscreener.com/news/latest/In-2022-the-dance-floor-is-empty--42638571/?utm_medium=RSS&utm_content=20221230",
    urlToImage:
      "https://www.zonebourse.com/images/ImagesTagged/zbimg_11427_800.png",
    publishedAt: "2022-12-30T14:42:20Z",
    content:
      "Those who thought they could avoid the storm by betting on big caps got it very wrong. Mark Zuckerberg isn't giving up on his Metaverse idea and is sending Meta shares into the deep end. The capitali… [+2513 chars]",
  },
  {
    source: { id: "wirtschafts-woche", name: "Wirtschafts Woche" },
    author: null,
    title: "Elektroautos 2023: Diese acht E-Modelle erwartet die Stromwelt",
    description:
      "Ob VWs E-Passat, eine neue China-Marke mit Akkutausch-Stationen oder der erste Maserati unter Strom – die Elektroauto-Neuheiten 2023 sorgen für reichlich Spannung.",
    url: "https://www.wiwo.de/unternehmen/auto/elektroautos-2023-diese-acht-e-modelle-erwartet-die-stromwelt/28894160.html",
    urlToImage:
      "https://www.wiwo.de/images/audi_etron_concept_159_4/28894168/3-format11240.jpg",
    publishedAt: "2022-12-30T14:38:48Z",
    content:
      "Nio ET5, ET7 und EL7\r\nNeben chinesischen Newcomern wie Cat, Wey oder BYD wagt auch Nio 2023 den Markteintritt in Deutschland. Die junge Marke positioniert sich nicht nur klar gegen Tesla, sie rollt a… [+747 chars]",
  },
  {
    source: { id: null, name: "Biztoc.com" },
    author: "wsj.com",
    title: "Tesla Stock Is Headed for Its Biggest-Ever Annual Decline",
    description:
      "Tesla Inc. is poised Friday to close the worst year in the stock’s history, having lost more than $700 billion in market valuation amid investor concerns about production disruptions, demand worries and Chief Executive Elon Musk‘s focus on Twitter Inc. The el…",
    url: "https://biztoc.com/x/6ad572f6a12edd84",
    urlToImage: "https://c.biztoc.com/p/6ad572f6a12edd84/og.webp",
    publishedAt: "2022-12-30T14:38:09Z",
    content:
      "Tesla Inc. is poised Friday to close the worst year in the stocks history, having lost more than $700 billion in market valuation amid investor concerns about production disruptions, demand worries a… [+389 chars]",
  },
  {
    source: { id: "cnn", name: "CNN" },
    author: "Nicole Goodkind, David Goldman",
    title:
      "Stocks are having their worst year since 2008. Bonds are even worse",
    description:
      "Wall Street is bidding goodbye -- and good riddance -- to 2022. It has been a year most investors would rather forget.",
    url: "https://www.cnn.com/2022/12/30/investing/dow-stock-market-2022/index.html",
    urlToImage:
      "https://media.cnn.com/api/v1/images/stellar/prod/221221112132-03-nyse-1214.jpg?c=16x9&q=w_800,c_fill",
    publishedAt: "2022-12-30T14:35:24Z",
    content:
      "Wall Street is bidding goodbye and good riddance to 2022. It has been a year most investors would rather forget.\r\nRussias invasion of Ukraine, a snarled supply chain and another year of Covid turned … [+3555 chars]",
  },
  {
    source: { id: null, name: "Biztoc.com" },
    author: "marketwatch.com",
    title: "Li Auto sees record EV deliveries in December",
    description:
      "Li Auto Inc. said Friday that it delivered more than 20,000 electric vehicles in December, which is more than 33% above the previous monthly record delivered last month. The China-based EV maker’s announcement of preliminary delivery data comes just days afte…",
    url: "https://biztoc.com/x/74e3b2a2e6fa862c",
    urlToImage: "https://c.biztoc.com/p/74e3b2a2e6fa862c/og.webp",
    publishedAt: "2022-12-30T14:34:04Z",
    content:
      "Li Auto Inc. said Friday that it delivered more than 20,000 electric vehicles in December, which is more than 33% above the previous monthly record delivered last month.\r\nThe China-based EV makers an… [+420 chars]",
  },
  {
    source: { id: null, name: "PRNewswire" },
    author: null,
    title:
      "Thinking about trading options or stock in Tesla, Merck, Amazon, Meta, or Johnson & Johnson?",
    description:
      "NEW YORK, Dec. 30, 2022 /PRNewswire/ -- InvestorsObserver issues critical PriceWatch Alerts for TSLA, MRK, AMZN, META, and JNJ. Click a link below then choose between in-depth options trade idea report or a stock score report. Options Report – Ideal trade ide…",
    url: "https://www.prnewswire.com/news-releases/thinking-about-trading-options-or-stock-in-tesla-merck-amazon-meta-or-johnson--johnson-301711430.html",
    urlToImage:
      "https://mma.prnewswire.com/media/1333368/InvestorsObserver_Logo.jpg?p=facebook",
    publishedAt: "2022-12-30T14:31:00Z",
    content:
      "NEW YORK, Dec. 30, 2022 /PRNewswire/ -- InvestorsObserver issues critical PriceWatch Alerts for TSLA, MRK, AMZN, META, and JNJ.\r\nClick a link below then choose between in-depth options trade idea rep… [+798 chars]",
  },
  {
    source: { id: null, name: "Abertoatedemadrugada.com" },
    author: "Carlos Martins",
    title: "Tesla revela quantas pessoas compraram o modo FSD",
    description:
      "A Tesla revelou que 285 mil pessoas pagaram pela polémica opção FSD (Full Self Driving) na América do Norte durante o ano de 2022.",
    url: "https://abertoatedemadrugada.com/2022/12/tesla-revela-quantas-pessoas-compraram.html",
    urlToImage:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjUv2b27ExdgTu1nT9jpRzVwocZsFsfa15d-518PIPlJmCxb_bx9ooQDW6zcS0LytniBsVABYq70ywmVS7taT7GB1KfQbsfNnP0he-Pabdjxhffe2M9DPvKlO6Goc6laCWi1gWR90Q1i9vl8o4HbAbDaYcnqLmGLuz--yOaG7z0GnlP0c30MlxrQnwb-w/w1200-h630-p-k-no-nu/teslaa.jpg",
    publishedAt: "2022-12-30T14:30:00Z",
    content:
      "A Tesla revelou que 285 mil pessoas pagaram pela polémica opção FSD (Full Self Driving) na América do Norte durante o ano de 2022.Numa altura em que a Tesla pode estar prestes a ser obrigada a deixar… [+1647 chars]",
  },
  {
    source: { id: null, name: "Www.df.cl" },
    author: "Diario Financiero, Rafaella Zacconi",
    title:
      "Acción de Tesla se encamina a cerrar su peor año en bolsa con la mira puesta en el papel de Elon Musk",
    description:
      "El fabricante de vehículos eléctricos liderado por Elon Musk completaría este viernes su cuarta semana en rojo.",
    url: "https://www.df.cl/mercados/bolsa-monedas/accion-de-tesla-cierra-su-peor-ano-en-bolsa-con-la-mira-puesta-en-elon-musk",
    urlToImage:
      "https://www.df.cl/noticias/site/artic/20221230/imag/foto_0000000520221230112140/Foto_Tesla.jpg",
    publishedAt: "2022-12-30T14:30:00Z",
    content:
      "Este martes, la acción de Tesla cayó a un mínimo de dos años. ¿La razón? Las dudas de los inversionistas sobre el manejo de Elon Musk tanto sobre la compañía de vehículos eléctricos como la recién ad… [+2753 chars]",
  },
];
export default blogdata;
